module.exports = __webpack_public_path__ + "static/media/2020.10.1迎国庆 庆中秋 主题活动.8b10a715.jpg";